var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9786 8.97909C30.1936 8.97909 30.2665 8.69156 30.0774 8.58937L16.0998 1.02534C16.0373 0.990694 15.961 0.992426 15.8986 1.02534L2.39608 8.58937C2.20878 8.6933 2.17192 8.97736 2.4984 8.97736L29.9786 8.97909Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01562 11.236H10.1894",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9124 11.236H19.0879",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8104 11.236H27.9842",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5883 13.3232V25.8583",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1111 13.3232V25.8583",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8027 13.3232V25.8583",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3239 13.3232V25.8583",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01733 13.3232V25.8583",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53845 13.3232V25.8583",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01562 27.9367H27.9841",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68567 30.0846H29.3144",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32.2341H31",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/BankIcon.03ebd4e688bca59d625da062927a8e76.svg";
export { ForwardRef as ReactComponent };